import RMSvgIcon from 'components/customComponents/CommonComponents/RMSvgIcon';
import React from 'react';
import { IStyle } from 'Styles';
import { PostTaskAction } from './SystemTask';

type PostCompletionActionProps = {
  closeClickHandler: (e) => void;
  actions: PostTaskAction[];
  actionResult: any;
};
export const PostCompletionAction = ({
  closeClickHandler,
  actions,
  actionResult,
}: PostCompletionActionProps) => {
  return (
    <div id={`postcompletionaction-wrapper`} style={styles.completionAction}>
      {actions &&
        actions.length > 0 &&
        actions.map((a, index) => {
          return (
            <div id={`postcompletionaction-${a.titleTip}`} key={index} {...(a.titleTip && { title: a.titleTip })}>
              <RMSvgIcon
                id={`postcompletionaction-${a.iconProps.name}-icon`}
                key={'PostActionIcon_' + a.iconProps.name + '_' + index}
                className="cursor-pointer"
                onClick={(e) => {
                  a.method(a.param, actionResult);
                }}
                {...a.iconProps}
              />
            </div>
          );
        })}
      <RMSvgIcon
        id={`postcompletionaction-close-icon`}
        name="Close"
        fill="#DA1E28"
        className="w-4 h-4 cursor-pointer"
        title="Clear"
        onClick={closeClickHandler}
      />
    </div>
  );
};

const styles: IStyle = {
  completionAction: {
    display: 'flex',
    gap: '0.5rem',
    alignItems: 'center',
  },
};
